import { httpClient, setResponseType } from '@/app/shared/services';
import { apiConstants } from '../config';

const URL = apiConstants.events;
const FROM_PLAN = `${URL}/from-parkings-plans-clients`;
const FROM_PLAN_BASE = `${URL}/from-parkings-plans-clients-per-minutes`;
const FROM_PLAN_TRIAL = `${URL}/from-parkings-plans-clients-trials`;
const FROM_PLAN_CUSTOM = `${URL}/from-parkings-plans-clients-customs`;

// Event by plan
const fetchEventFromProductPlan = (planContractID, page = null) => {
  if (page != null) {
    return httpClient.post(`${FROM_PLAN}/${planContractID}?page=${page}`, {}).then(res => res.data)
  }
  else {
    return httpClient.post(`${FROM_PLAN}/${planContractID}`, {}).then(res => res.data)
  }
};

const fetchEventFromProductAllPlan = (type, planContractID, page = null) => {

  const URL_PRODUCT = getProductUrl(type);

  if (page != null) {
    return httpClient.post(`${URL_PRODUCT}/${planContractID}?page=${page}`, {}).then(res => res.data)
  }
  else {
    return httpClient.post(`${URL_PRODUCT}/${planContractID}`, {}).then(res => res.data)
  }
};

const getProductUrl = (planType) => {

  const PAYMENT_DETAIL = {
    'perminutes': `${FROM_PLAN_BASE}`,
    'base': `${FROM_PLAN_BASE}`,
    'prepago': `${FROM_PLAN}`,
    'custom': `${FROM_PLAN_CUSTOM}`,
    'trial': `${FROM_PLAN_TRIAL}`
  }
  const DEFAULT = `${FROM_PLAN}`;

  return PAYMENT_DETAIL[planType] || DEFAULT
}


export {
  fetchEventFromProductPlan,
  fetchEventFromProductAllPlan,
};